'use client';
import { PageLayout } from '@xtnd/web/shared/layout';
import { MatterArDetailProvider } from '../components/common';
import EscalationReport from '../components/reports/EscalationReport';

export default function EscalationReportPage() {
  return (
    <PageLayout
      title="Escalation Report"
      description="View all collection attempts escalated to Attorney or Leadership."
    >
      <MatterArDetailProvider>
        <EscalationReport />
      </MatterArDetailProvider>
    </PageLayout>
  );
}
